<template>
  <main>
    <div class="common-report qtime-activity-view">
      <div>
        <div>
          <qtime-report-header></qtime-report-header>
          <finance-report-relation></finance-report-relation>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import FinanceReportRelation from "./finance-report/FinanceReportRelation";
const QtimeReportHeader = () => import("./QtimeReportHeader");
export default {
  name: "FinanceReport",
  components: { FinanceReportRelation, QtimeReportHeader },
  computed: {
    // filter: function() {
    //   return this.$store.state.reports.qcentrisCountryTurnoverFilter;
    // }
  },
  beforeMount() {
    //this.fetchData();
  },
  methods: {
    // fetchData: function() {
    //   this.$store.dispatch("fetchCountryTurnover", this.filter);
    //   this.$store.dispatch("fetchReportAggregates");
    // }
  }
};
</script>

<style scoped>
.qtime-activity-view {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
}
</style>